import React from 'react';
import { Icon, IconProps } from '@carta/ink';
import { StyledSideNavIcon, StyledSideNavIconBadge } from './styles';

export type SideNavIconProps = {
  /** Icon type */
  icon?: IconProps['type'];
  /** Badged state modifier */
  isBadged?: boolean;
  /** Active state modifier */
  isActive?: boolean;
  /** Simple description for screen readers */
  meaning?: string;
};

const SideNavIcon = ({ icon, isBadged, isActive = false, meaning }: SideNavIconProps) => {
  return (
    <StyledSideNavIcon isActive={isActive}>
      <Icon size="lg" type={icon} aria-hidden="true" meaning={meaning} />
      <StyledSideNavIconBadge isBadged={isBadged} aria-hidden="true" />
    </StyledSideNavIcon>
  );
};

SideNavIcon.displayName = 'SideNav.Icon';

export default SideNavIcon;
